import { render, staticRenderFns } from "./PurchaseOption.vue?vue&type=template&id=0f6a526c&"
import script from "./PurchaseOption.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports